/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
/* eslint-disable import/no-cycle */
import React, { useRef, useState, useEffect } from 'react';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { ButtonComponent, classNames } from '@syncfusion/ej2-react-buttons';
import { format, parseISO } from 'date-fns';
import { Legend,
  SeriesCollectionDirective,
  ChartComponent,
  SeriesDirective,
  DateTime,
  LineSeries,
  Export,
  Inject,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  PieSeries,
  AccumulationChartComponent } from '@syncfusion/ej2-react-charts';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { DataManager, Query } from '@syncfusion/ej2-data';

import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Selection, Toolbar, Edit, Sort, Filter,
  ColumnChooser,
  Resize,
} from '@syncfusion/ej2-react-grids';

import { useNavigate } from 'react-router-dom';
import { AMap, Header } from '../components';
import { useStateContext } from '../contexts/ContextProvider';
import { statsWorkResteGrid } from '../data/dummy';
import armband from '../data/watchsketch.png';

import './Zackat.css';

const Stats = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=notificationevents');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const { zRenderMode, isMobile, setNotificationDevice } = useStateContext();
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [data, setData] = useState([]);
  const [orgs, setOrgs] = useState([]);
  const [associates, setAssociates] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [heartrates, setHeartRates] = useState([]);
  const [temperatures, setTemperatures] = useState([]);
  const [numActive, setNumActive] = useState(0);
  const [selOrganization, setOrganization] = useState([]);
  const [exposureData, setExposureData] = useState([]);
  const [selFrequency, setFrequency] = useState('na');
  const [loading, setLoading] = useState(true);
  const [workrestLoaded, setWorkRest] = useState(false);
  const [associateCount, setAssociateCount] = useState(0);
  const [inventoryCount, setInventoryCount] = useState(0);
  const [managerCount, setManagerCount] = useState(0);
  const [mgrData, setMgrData] = useState([]);
  const [jobs, setJobs] = useState([]);
  const grid = useRef(null);
  const frequency = [
    { value: 'na', text: 'Not Specified' },
    { value: 'day', text: 'Day' },
    { value: 'week', text: 'Week' },
    { value: 'month', text: 'Month' },
  ];
  const scoreCard = [
    { _id: '0', score: '-1', desc: '🥏 HYPO', action: 'Caution advised' },
    { _id: '1', score: '0-25', desc: '✅ BASELINE', action: 'Continue monitoring' },
    { _id: '2', score: '25-50', desc: '💗 MODERATE', action: 'Hydrate, increase rest breaks' },
    { _id: '3', score: '50-80', desc: '🌡 ELEVATED', action: 'Manager intervention, rest, hydrate' },
    { _id: '4', score: '80-', desc: '🚓 SEVERE', action: 'Stop work, cool down, medical evaluation' },
  ];
  const chartData = [
    { x: 'Core Temperature', y: 35 },
    { x: 'Heart Rate', y: 25 },
    { x: 'Rate of Temperature increase', y: 15 },
    { x: 'Heart Rate recovery', y: 10 },
    { x: 'Time in heat', y: 10 },
    { x: 'GPS isolation', y: 5 },
  ];
  const containerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)', // Creates 2 equal columns
    gap: '16px', // Spacing between the divs
    padding: '16px',
  };

  const boxStyle = {
    backgroundColor: '#F6821E7f',
    color: 'black',
    padding: '24px',
    textAlign: 'center',
    borderRadius: '8px',
    fontSize: '1.25rem',
  };
  const lboxStyle = {
    backgroundColor: '#F6821E7f',
    color: 'black',
    padding: '24px',
    textAlign: 'left',
    borderRadius: '8px',
    fontSize: '1.25rem',
  };
  const mapStyle = {
    backgroundColor: '#F6821E7f',
    color: 'black',
    width: '42vw',
    padding: '24px',
    textAlign: 'left',
    borderRadius: '8px',
    fontSize: '1.25rem',
  };
  const orgStyle = {
    backgroundColor: 'white',
    color: 'black',
    padding: '24px',
    textAlign: 'center',
    borderRadius: '8px',
    fontSize: '1.25rem',
  };
  const pageSettings = { pageSize: 8 };
  function formatPhoneNumber(phoneNumberString) {
    if (!phoneNumberString || phoneNumberString.length <= 0) {
      return null;
    }
    if (phoneNumberString && phoneNumberString.length === 10) {
      phoneNumberString = `1${phoneNumberString}`;
    }
    const cleaned = (`${phoneNumberString}`).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      const intlCode = (match[1] ? '+1 ' : '');
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
  }

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      setLoading(true);
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/organizations?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      if (mydata) {
        // set state when the data received
        setData(mydata);
        setOrgs(mydata.organization);
        setLoading(false);
      }
    };
    dataFetch();
  }, []);
  useEffect(() => {
    const fetchCount = async () => {
      usr.organizationid = selOrganization;
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/associates?count=true&${query}&specific=true`;
      if (!usr.loggedIn) {
        navigate('/login');
        return;
      }
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      setAssociateCount(mydata.associateCount);
      setInventoryCount(mydata.inventoryCount);
      setManagerCount(mydata.managerCount);
    };
    fetchCount();
  }, [selOrganization]);
  useEffect(() => {
    const getManagerData = async () => {
      if (!selOrganization || selOrganization.length === 0) {
        return;
      }
      usr.organizationid = selOrganization;
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/managers?${query}&orgid=${selOrganization}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          let mymgr = [];
          if (mydata && mydata.length > 0) {
            mydata.forEach((m) => {
              m.name = `${m.first} ${m.last}`;
            });
            mymgr = mydata;
          }
          setMgrData(mymgr);
        })
        .catch((error) => {
          setMgrData([]);
        });
    };
    getManagerData();
  }, [selOrganization]);

  useEffect(() => {
    usr.organizationid = 'na';
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    const associateFetch = async () => {
      if (!selOrganization || selOrganization.length === 0) {
        return;
      }
      setLoading(true);
      usr.organizationid = selOrganization;
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/associates?${query}&limit=0&specific=true`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          // Orig set state when the data received
          if (!mydata.associates) {
            setAssociates([]);
          } else {
            const myassociates = [];
            mydata.associates.map((item) => (
              myassociates.push({ value: item._id, text: item.name })
            ));
            setAssociates(mydata.associates);
            let num = 0;
            mydata.associates.forEach((a) => {
              if (a.device && a.device.length > 0) {
                num += 1;
              }
            });
            setNumActive(num);
          }
        })
        .catch((error) => {
          console.error(error.message);
        });
      setLoading(false);
    };
    associateFetch();
  }, [selOrganization]);
  useEffect(() => {
    const workFetch = async () => {
      usr.organizationid = selOrganization;
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      setExposureData([]);

      const to = new Date();
      const from = new Date();
      from.setDate(from.getDate() - selFrequency);
      setWorkRest(false);
      const url = `${REACT_APP_API_ENDPOINT}/reports?report=workrest&${query}&from=${(from.getTime() / 1000).toFixed(0)}&to=${(to.getTime() / 1000).toFixed(0)}&specific=true`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.workrest) {
            setExposureData(response.workrest);
          } else {
            setExposureData([]);
          }
        })
        .catch((error) => {
          console.error(error.message);
        });
      setWorkRest(true);
    };
    workFetch();
  }, [selOrganization, selFrequency]);
  useEffect(() => {
    usr.organizationid = 'na';
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }

    const vitalFetch = async () => {
      if (!selOrganization || selOrganization.length === 0) {
        return;
      }
      usr.organizationid = selOrganization;
      usr.frequency = selFrequency;
      setHeartRates([]);
      setTemperatures([]);
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      let url = `${REACT_APP_API_ENDPOINT}/reports?report=hrEvents&${query}`;

      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          // Orig set state when the data received
          const myhr = [];
          if (mydata && mydata.length > 0) {
            mydata.forEach((a) => {
              const myDate = new Date(a.Year, a.Month, a.Day);
              // const newrec = [];
              myhr.push({
                title: a.Name,
                x: myDate,
                y: a.AvgValue,
              });
            // myhr.push(newrec);
            });
            // Group data by 'title'
            const groupedData = myhr.reduce((acc, item) => {
              if (!acc[item.title]) {
                acc[item.title] = [];
              }
              acc[item.title].push(item);
              return acc;
            }, {});
            setHeartRates(groupedData);
          } else {
            setHeartRates([]);
          }
        })
        .catch((error) => {
          console.error(error.message);
        });
      url = `${REACT_APP_API_ENDPOINT}/reports?report=tempEvents&${query}`;

      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          // Orig set state when the data received
          const myhr = [];
          if (mydata && mydata.length > 0) {
            mydata.forEach((a) => {
              const myDate = new Date(a.Year, a.Month, a.Day);
              myhr.push({
                title: a.Name,
                x: myDate,
                y: a.AvgValue,
              });
            });
            // Group data by 'title'
            const groupedData = myhr.reduce((acc, item) => {
              if (!acc[item.title]) {
                acc[item.title] = [];
              }
              acc[item.title].push(item);
              return acc;
            }, {});
            setTemperatures(groupedData);
          } else {
            setTemperatures([]);
          }
        })
        .catch((error) => {
          console.error(error.message);
        });
    };
    vitalFetch();
  }, [selOrganization, selFrequency]);
  useEffect(() => {
    // fetch data
    const dataFetch = async () => {
    // limit associates to the overall selection
      usr.limit = '100';
      usr.specific = true;
      usr.organizationid = selOrganization;
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/notifications?${query}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          // set state when the data received
          setAlerts(mydata);
        })
        .catch((error) => {
          console.error(error.message);
        });
    };
    dataFetch();
  }, [selOrganization]);
  useEffect(() => {
    // limit associates to the overall selection
    usr.organizationid = selOrganization;
    // fetch data
    const dataFetch = async () => {
      try {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        const url = `${REACT_APP_API_ENDPOINT}/jobs?${query}`;
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json()
          .catch((err) => {
            console.error('Error parsing JSON:', err);
            return null;
          });
        setJobs(mydata.jobs);
      } catch (err) {
        setJobs([]);
      }
    };
    // set state when the data received
    dataFetch();
  }, [selOrganization]); // mapDisplay

  const organizations = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(orgs),
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };

  if (loading) {
    return <p>Loading... </p>;
  }
  return (
    <div className={!isMobile ? 'm-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh' : 'bg-white rounded-3xl zackat-divalh w-full mt-44'}>
      <Header category="Administration" title="Organization Statistics" />
      <div style={containerStyle}>
        <div style={lboxStyle}> <img src={armband} width={35} height={30} /> {inventoryCount} (Number of W<sup>3</sup> Devices)</div>
        <div style={lboxStyle}> 👫 {managerCount} (Number of Active W<sup>3</sup> Managers)</div>
        <div style={lboxStyle}> 🕺 {numActive} (Number of Associates assigned to W<sup>3</sup> Devices)</div>
        <div style={lboxStyle}> 👥 {associateCount} (Number of W<sup>3</sup> Associates)</div>
        <div style={orgStyle}>
          <DropDownListComponent
            id="ddlelement"
            floatLabelType="Auto"
            cssClass="e-outline"
            dataSource={organizations.params.dataSource}
            fields={organizations.params.fields}
            placeholder="Select Organization"
            // enabled={false} // Disables the entire component
            value={selOrganization}
            change={(v) => { setOrganization(v.value); }}
          />
        </div>
        <div style={orgStyle}>
          <DropDownListComponent
            id="ddlelement"
            floatLabelType="Auto"
            cssClass="e-outline"
            dataSource={frequency}
            fields={{ value: 'value', text: 'text' }}
            placeholder="Select Frequency"
            // enabled={false} // Disables the entire component
            value={selFrequency}
            change={(v) => { setFrequency(v.value); }}
          />
        </div>
        {selOrganization && selOrganization.length > 0 && (
        <div style={boxStyle}>
          <h2>WORKER STATUS</h2>
          <GridComponent
            dataSource={associates}
            allowPaging
            pageSettings={pageSettings}
            allowTextWrap
            allowSorting
            allowFiltering
          >
            <ColumnsDirective>
              <ColumnDirective field="_id" headerText="ID" visible={false} width="120" isPrimaryKey textAlign="Left" />
              <ColumnDirective field="name" headerText="Worker" width="120" textAlign="Left" />
              <ColumnDirective field="heartrate.reading" headerText="Heart Rate (bpm)" width="100" textAlign="Left" />
              <ColumnDirective field="temperature.reading" headerText="Core Temp °F" width="100" textAlign="Left" />
              <ColumnDirective field="latlng.location" headerText="GPS Location" width="100" textAlign="Left" />
              <ColumnDirective field="exposuretime" headerText="Exposure time" width="120" textAlign="Left" />
              <ColumnDirective field="risk" headerText="Risk Score" width="100" textAlign="Left" />
              <ColumnDirective field="jobtask" headerText="Job Task" width="100" textAlign="Left" />
              <ColumnDirective field="action" headerText="Action" width="150" textAlign="Left" />
            </ColumnsDirective>

            {/* Inject features into the grid dynamically */}
            <Inject services={[Page, Sort, Filter]} />
          </GridComponent>
        </div>
        )}
        {selOrganization && selOrganization.length > 0 && (
        <div style={mapStyle}>
          <h2>LIVE WORKER MAP</h2>
          <div className="mt-10">
            <AMap active org={selOrganization} />
          </div>
        </div>
        )}
        {selOrganization && selOrganization.length > 0 && (
        <div style={boxStyle}><h1> 🛎 (Priority Alerts)</h1>
          {associates.map((a) => (
            <div style={containerStyle}>
              {a.risk >= 80 && (
                <>
                  <div style={lboxStyle}>
                    <h1>SEVERE: {a.name}</h1>
                    <p>Core: Temperature {a.temperature.reading || ''}</p>
                    <p>Heart Rate {a.heartrate.reading || ''}</p>
                    <p>Location {a.latlng.location || ''}</p>
                    <p>Last Movement {a.activity && a.activity.timestamp ? format(parseISO(a.activity.timestamp), 'hh:mm') : ''}</p>
                  </div>
                  <div style={lboxStyle}>
                    <p>Dispatch nearest responder</p>
                    {orgs.map((o) => {
                      if (o._id === a.organizationid) {
                        return (
                          <p key={o}>
                            <b><p>Contact Corportate {o.title} : {formatPhoneNumber(o.phone)}</p></b>
                          </p>
                        );
                      }
                      return null;
                    })}
                    <p>Contact Manager(s)
                      {a.managers.map((m) => {
                        const result = mgrData.find(({ _id }) => _id === m);
                        if (!result) return null;
                        return (
                          <p key={m}>
                            {result.first} {result.last} : {formatPhoneNumber(result.mobile)}
                          </p>
                        );
                      })}
                    </p>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
        )}
        {selOrganization && selOrganization.length > 0 && (
        <div style={boxStyle}><h1>⚠ (High Risk)</h1>
          {associates.map((a) => (
            <div style={containerStyle}>
              {a.risk >= 50 && a.risk < 80 && (
              <>
                <div style={lboxStyle}>
                  <h1>ELEVATED: {a.name}</h1>
                  <p>Core: Temperature {a.temperature.reading || ''}</p>
                  <p>Heart Rate {a.heartrate.reading || ''}</p>
                  <p>Location {a.latlng.location || ''}</p>
                  <p>Last Movement {a.activity && a.activity.timestamp ? format(parseISO(a.activity.timestamp), 'hh:mm') : ''}</p>
                </div>
                <div style={lboxStyle}>
                  <p>Mandatory rest</p>
                  <p>Hydrate</p>
                  <p>Contact Manager(s)
                    {a.managers.map((m) => {
                      const result = mgrData.find(({ _id }) => _id === m);
                      if (!result) return null;
                      return (
                        <p key={m}>
                          {result.first} {result.last} : {formatPhoneNumber(result.mobile)} email result.email
                        </p>
                      );
                    })}
                  </p>
                </div>
              </>
              )}
            </div>
          ))}
        </div>
        )}
        {selOrganization && selOrganization.length > 0 && (
        <div style={boxStyle}> 💹 (Physiological Trends)
          <div style={containerStyle}>
            <div style={boxStyle}>HeartRate
              <ChartComponent
                id="hrChart"
            // ref={(trafficChart) => { traffic1 = trafficChart; }}
                style={{ textAlign: 'center' }}
            // load={Chartload}
                legendSettings={{ visible: true }}
                primaryXAxis={{ valueType: 'DateTime', labelFormat: 'M/y', labelRotation: -45, majorGridLines: { width: 0 }, intervalType: 'Months', edgeLabelPlacement: 'Shift' }}
                primaryYAxis={{ labelFormat: '{value}', lineStyle: { width: 0 }, maximum: 160, interval: 10, majorTickLines: { width: 0 }, minorTickLines: { width: 0 } }}
                chartArea={{ border: { width: 0 } }}
              >
                <Inject services={[LineSeries, DateTime, Legend, Export]} />
                <SeriesCollectionDirective>
                  {Object.keys(heartrates).map((name) => (
                    <SeriesDirective
                      key={name}
                      xName="x"
                      dataSource={heartrates[name]}
                      yName="y"
                      name={name}
                      type="Line"
                      width={2}
                      marker={{ visible: true }}
                    />
                  ))}
                </SeriesCollectionDirective>
              </ChartComponent>
            </div>
            <div style={boxStyle}>Temperature
              <ChartComponent
                id="tempChart"
            // ref={(trafficChart) => { traffic1 = trafficChart; }}
                style={{ textAlign: 'center' }}
            // load={Chartload}
                legendSettings={{ visible: true }}
                primaryXAxis={{ valueType: 'DateTime', labelFormat: 'M/y', labelRotation: -45, majorGridLines: { width: 0 }, intervalType: 'Months', edgeLabelPlacement: 'Shift' }}
                primaryYAxis={{ labelFormat: '{value}', lineStyle: { width: 0 }, maximum: 160, interval: 10, majorTickLines: { width: 0 }, minorTickLines: { width: 0 } }}
                chartArea={{ border: { width: 0 } }}
              >
                <SeriesCollectionDirective>
                  {Object.keys(temperatures).map((name) => (
                    <SeriesDirective
                      key={name}
                      xName="x"
                      dataSource={temperatures[name]}
                      yName="y"
                      name={name}
                      type="Line"
                      width={2}
                      marker={{ visible: true }}
                    />
                  ))}
                  <Inject services={[LineSeries, DateTime, Legend, Export]} />
                </SeriesCollectionDirective>
              </ChartComponent>
            </div>
          </div>
        </div>
        )}
        {selOrganization && selOrganization.length > 0 && workrestLoaded && (
        <div style={boxStyle}> 💪 (Exposure Summary)
          <div style={{ width: '900px' /* or any parent width */ }}>
            <GridComponent
              dataSource={exposureData}
              allowPaging
              pageSettings={pageSettings}
              allowTextWrap
              allowSorting
              width="100%"
              allowFiltering
              reg={grid}
            >
              <ColumnsDirective>
                {statsWorkResteGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
              </ColumnsDirective>
              {/* Inject features into the grid dynamically */}
              <Inject services={[Page, Sort, Filter]} />
            </GridComponent>
          </div>
        </div>
        )}
        {selOrganization && selOrganization.length > 0 && (
        <div style={boxStyle}>
          <h1>🌝 (Location Risk Analysis))</h1>
          <GridComponent
            dataSource={jobs}
            allowPaging
            pageSettings={pageSettings}
            allowTextWrap
            allowSorting
            allowFiltering
          >
            <ColumnsDirective>
              <ColumnDirective field="Id" headerText="ID" visible={false} width="120" isPrimaryKey textAlign="Left" />
              <ColumnDirective field="title" headerText="Title" width="100" textAlign="Left" />
              <ColumnDirective field="description" headerText="Description" width="150" textAlign="Left" />
              <ColumnDirective field="manager" headerText="Manager" width="120" textAlign="Left" />
              <ColumnDirective field="aqi.hourlyForecasts.0.indexes.0.aqi" headerText="Air Quality" width="120" textAlign="Left" />
              <ColumnDirective field="aqi.hourlyForecasts.0.indexes.0.category" headerText="Air Category" width="120" textAlign="Left" />
              <ColumnDirective field="forecast.forecastDays.0.feelsLikeMaxTemperature.degrees" headerText="Heat Index" width="120" textAlign="Left" />
              <ColumnDirective field="forecast.forecastDays.0.feelsLikeMaxTemperature.unit" headerText="Scale" width="120" textAlign="Left" />
            </ColumnsDirective>
            {/* Inject features into the grid dynamically */}
            <Inject services={[Page, Sort, Filter]} />
          </GridComponent>
        </div>
        )}
        {selOrganization && selOrganization.length > 0 && (
        <div style={boxStyle}>
          <h1>👹 (Alert History)</h1>
          <h1>{alerts.results && alerts.results.totalNotifications && alerts.results.totalNotifications.toLocaleString('en-US')} 🛎 (safety notifications for {new Date().getFullYear()})
            {alerts.results && alerts.results.ackNotifications && alerts.results.totalNotifications && ((alerts.results.totalHeat / alerts.results.totalNotifications) * 100).toFixed(0)}% ⚠ (heat related stress events)
          </h1>
          <h1>{alerts.results && alerts.results.ackNotifications && alerts.results.totalNotifications && ((alerts.results.ackNotifications / alerts.results.totalNotifications) * 100).toFixed(0) }% &#x2406; (intervention acknowledgement rate)
            {alerts.results && alerts.results.totalEvents && alerts.results.totalEvents.toLocaleString('en-US')} ⌖ (environmental sensor readings collected)
          </h1>
          <GridComponent
            dataSource={alerts.notifications}
            allowPaging
            pageSettings={pageSettings}
            allowTextWrap
            allowSorting
            allowFiltering
          >
            <ColumnsDirective>
              <ColumnDirective field="_id" headerText="ID" visible={false} width="120" isPrimaryKey textAlign="Left" />
              <ColumnDirective field="time" headerText="Time" width="100" textAlign="Left" />
              <ColumnDirective field="name" headerText="Worker" width="120" textAlign="Left" />
              <ColumnDirective field="desc" headerText="Event" width="150" textAlign="Left" />
            </ColumnsDirective>
            {/* Inject features into the grid dynamically */}
            <Inject services={[Page, Sort, Filter]} />
          </GridComponent>
        </div>
        )}
        {selOrganization && selOrganization.length > 0 && (
        <div style={lboxStyle}>
          <h1>🎯 (HEAT STRESS RISK SCORE))</h1>
          <p>Composite score (-1 to 99) using multiple physiological and environmental factors</p>
          <AccumulationChartComponent>
            <Inject services={[PieSeries]} />
            <AccumulationSeriesCollectionDirective>
              <AccumulationSeriesDirective
                dataSource={chartData}
                xName="x"
                yName="y"
                type="Pie"
                innerRadius="50%"
              />
            </AccumulationSeriesCollectionDirective>
          </AccumulationChartComponent>
        </div>
        )}
        {selOrganization && selOrganization.length > 0 && (
        <div style={boxStyle}>
          <h1>⭕ (RISK SCORE GUIDE))</h1>
          <GridComponent
            dataSource={scoreCard}
            allowPaging
            pageSettings={pageSettings}
            allowTextWrap
            allowSorting
            allowFiltering
          >
            <ColumnsDirective>
              <ColumnDirective field="_id" headerText="ID" visible={false} width="120" isPrimaryKey textAlign="Left" />
              <ColumnDirective field="score" headerText="TimScoree" width="100" textAlign="Left" />
              <ColumnDirective field="desc" headerText="Description" width="150" textAlign="Left" />
              <ColumnDirective field="action" headerText="Recommended Action" width="120" textAlign="Left" />
            </ColumnsDirective>
            {/* Inject features into the grid dynamically */}
            <Inject services={[Page, Sort, Filter]} />
          </GridComponent>
        </div>
        )}
      </div>
    </div>
  );
};
export default Stats;
